/**
 * Textos del banner «primeros 100 de la app» (puro, sirve en cliente y servidor).
 * Regla de marca: sin precios, créditos, cuotas ni «IA».
 */
export function campaignBannerCopy(status) {
  if (!status?.open || !(status.remaining > 0)) return null;
  const { remaining, cap, trialDays } = status;
  return {
    title: `Primeros ${cap} en la app: ${trialDays} días gratis de Profesional`,
    counter: remaining === 1 ? 'Queda 1 cupo' : `Quedan ${remaining} de ${cap} cupos`,
    cta: 'Descargar en el App Store',
  };
}
